import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

import {
  Row,
  Card,
  CardBody,
  Input,
  FormGroup,
  Label,
  Button,
  Table,
  CardFooter,
  Col,
} from "reactstrap";
import { useHistory,Link,useParams } from "react-router-dom";
import { Colxx } from "../../../components/common/CustomBootstrap";
import SkillSearch from "./skillsearch";
import SoftSkillSearch from "./softskillsearch";
import LanguageSearch from "./languagessearch";
import CertificationSearch from "./certificationsearch";
import { SearchCandidateService } from "../../../services/SearchCandidateService";
import Pagination from "../../../containers/pages/Pagination";
import { isNullOrEmpty } from "../../../config/ENV";
import { formattedMobileNumber } from "../../../utilities/phonenumberutility";
import vector from "../../../../src/assets/img/searchcandidates/Vectordel.png";
import SearchPlaceComponent from "../../components/SearchPlaceComponent";
import {dayDifference} from "../../../utilities/daysutility";
import {dateDifference} from "../../../utilities/dateutility"
// import { showLocalDateTime } from "../../../utilities/timeutility";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const SearchCandidate = (props) => {
  const {candidateid} =useParams();
  const [languageList, setLanguageList] = useState([]);
  const location = useLocation();
  const idsBackList = location.state?.idsBackList;
  // const backPageList= location.state?.backPageList;
  // console.log("back selected list", JSON.stringify(idsBackList))
  const { id,searchId,candidateId } = useParams();
  const [search, setSearch] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState();
  const history = useHistory();
  const [size, setSize] = useState();
  const [selectedPageSize, setSelectedPageSize] = useState(2);
  const startIndex = (currentPage - 1) * selectedPageSize;
  const endIndex = currentPage * selectedPageSize;
  const [totalPage, setTotalPage] = useState(1);
  const [candidates, setCandidates] = useState([]);
  const [certificationList, setCertificationList] = useState([]);
  const [softSkillList, setSoftSkillList] = useState([]);
  const [skillList, setSkillList] = useState([]);
  const [totalSkillIds, setTotalSkillIds] = useState([]);
  const [languageIds, setLanguageIds] = useState([]);
  const [emailPhoneKeywords, setEmail] = useState("");
const [firstName, setFirstName]= useState("");
const [lastName, setLastName]= useState("");
  const [distance, setDistance] = useState("");
  const [peerraters, setPeerRaters] = useState("");
  const [days, setDays] = useState("");
  const [state, setStateValue] = useState("");
  const [jobId, setJobId] = useState("");
  const [totalSkillList, setTotalSkillList] = useState([]);

  const [deleteSkill, setDeleteSkill] = useState([]);
  const [deleteSoftSkill, setDeleteSoftSkill] = useState([]);
  const [deleteCertification, setDeleteCertification] = useState([]);
  const [deleteLanguage, setDeleteLangauge] = useState([]);
  const [idsList, setIdsList] = useState([]);
  const [invites, setInvites] = useState([]);
  const [candId, setCandId] = useState([]);
  const [pageList, setPageList] = useState([]);
  const [responseList, setResponseList] = useState([]);

  const [address, setAddress] = useState({
    street: "",
    area: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
    latitude: "",
    longitude: "",
  });

  const handleMouseEnter = (id) => {
    setCandId(id);
    setShowTooltip(true);
  };
  const handleToolTip = (id) => {
    // setShowTooltip(false);
    setCandId(id);
    setShowTooltip((showTooltip) => !showTooltip);
  }
  

  const [showTooltip, setShowTooltip] = useState(false);
  const Search = () => {
    // if((isNullOrEmpty(distance)) && (!isNullOrEmpty(address.latitude))&& (!isNullOrEmpty(address.longitude)) ){
    //   toast.error("Please search with miles");
    //   return
    // }     else
    //  if((!isNullOrEmpty(distance)) && (isNullOrEmpty(address.latitude))&& (isNullOrEmpty(address.longitude)) ){
    //   toast.error("Please search with address");
    //   return
    // }
    setSearch(true);
    getCandidatesList();
  };
  let count = 0;


  useEffect(() => {
    var arr = [];
    var array = [];
    for (var i = 0; i < languageList.length; i++) {
      array.push(languageList[i].skillId);
    }

    for (var i = 0; i < certificationList.length; i++) {
      arr.push(certificationList[i].skillId);
    }
    for (var i = 0; i < softSkillList.length; i++) {
      arr.push(softSkillList[i].skillId);
    }
    for (var i = 0; i < skillList.length; i++) {
      arr.push(skillList[i].skillId);
    }

    setTotalSkillIds(arr);
    setLanguageIds(array);
    setTotalSkillList([
      ...skillList,
      ...softSkillList,
      ...languageList,
      ...certificationList,
    ]);
  }, [certificationList, softSkillList, skillList, languageList]);

  useEffect(() => {
    getCandidatesList(currentPage);
     // if (!isNullOrEmpty(idsBackList)) {
    //   if (idsBackList.idsList.length > 0) {
    //     console.log("if consolebacklist", JSON.stringify(idsBackList.idsList));
    //     setIdsList(idsBackList.idsList);
    //     // setInvites(idsBackList.idsList);
    //   }
    // }
    // if(!isNullOrEmpty(backPageList)&& backPageList !=undefined){
    //   if(backPageList.length>0){
    //     setPageList(backPageList)
    //   }
    // }
  }, [itemsPerPage, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedPageSize]);

  const deleteItem = (skill) => {
    if ([...skillList].includes(skill)) {
      setSkillList(skillList.filter((item) => item.id !== skill.id));
      setDeleteSkill(skillList.filter((item) => item.id !== skill.id));
    } else if ([...softSkillList].includes(skill)) {
      setSoftSkillList(softSkillList.filter((item) => item.id !== skill.id));
      setDeleteSoftSkill(softSkillList.filter((item) => item.id !== skill.id));
    } else if ([...certificationList].includes(skill)) {
      setCertificationList(
        certificationList.filter((item) => item.id !== skill.id)
      );
      setDeleteCertification(
        certificationList.filter((item) => item.id !== skill.id)
      );
    } else if ([...languageList].includes(skill)) {
      setLanguageList(languageList.filter((item) => item.id !== skill.id));
      setDeleteLangauge(languageList.filter((item) => item.id !== skill.id));
    }
  };
  const getCandidatesList = (currentpage) => {
    if (itemsPerPage === undefined || itemsPerPage === "") {
      itemsPerPage = 25;
    }

    let latitude = "";
    if (!isNullOrEmpty(address.latitude)) {
      latitude = address.latitude;
    }

    let longitude = "";
    if (!isNullOrEmpty(address.longitude)) {
      longitude = address.longitude;
    }

    setCurrentPage(currentpage);
    SearchCandidateService.getSearchCandidate(
      emailPhoneKeywords,
      firstName,
      lastName,
      distance,
      location,
      state,
      peerraters,
      days,
      jobId,
      totalSkillIds,
      languageIds,
      itemsPerPage,
      currentpage,
      latitude,
      longitude
    ).then((response) => {
      let size = response.data.size;
      setSize(size);
      try {
        if (response.data !== null) {
          setCandidates(response.data.candidates);
          setResponseList(response.data.candidates);

          var candidateList = response.data.candidates;

          if (!isNullOrEmpty(candidateList)) {
            setCandId(candidateList.id);
          }
          const pages = Math.floor(size / itemsPerPage);
          if (Math.round(size % itemsPerPage) > 0) {
            const totalPages = pages + 1;
            setTotalPage(totalPages);
          } else {
            const totalPages = pages;
            setTotalPage(totalPages);
          }
        }
      } catch (err) {
        console.log("error" + JSON.stringify(err));
      }
    });
  };

  const showCityState = (address) => {
    const add = [];
    if (!isNullOrEmpty(address)) {
      if (!isNullOrEmpty(address.city)) {
        add.push(address.city);
      }

      if (!isNullOrEmpty(address.state)) {
        add.push(address.state);
      }
    }
    return add.join(", ");
  };

  function handleItemsPerChange(e, key) {
    setItemsPerPage(e.target.value);

    setCurrentPage(1);
  }

  function onChangePage(e) {
    setCurrentPage(e);
  }

  const languageFunction = (languageList) => {
    setLanguageList(languageList);
  };

  const skillSearchFunction = (skillList) => {
    setSkillList(skillList);
  };

  const softSkillFunction = (softSkill) => {
    setSoftSkillList(softSkill);
  };

  const certificationSearchFunction = (certificationList) => {
    setCertificationList(certificationList);
  };

  const checkFunction = (e, item) => {
    if (e.target.checked) {
      setIdsList([...idsList, item.id]);
    } else if (e.target.checked === false) {
      if ([...idsList].includes(item.id)) {
        setIdsList(idsList.filter((id) => id !== item.id));
      }
    }
  };

  const checkAllFunction = (e) => {
    if (e.target.checked) {
      let x = [...pageList];

      setPageList([...x, currentPage]);

      let y = [...invites];
      setInvites([...invites, ...responseList]);

      let z1 = [];
      const invitesList = [...invites, ...responseList].map((item) =>
        z1.push(item.id)
      );
      setIdsList(z1);
    } else {
      setPageList(pageList.filter((item) => item !== currentPage));
      let z = [];
      let k = [];
      let h = [];
      for (let x1 of responseList) {
        h.push(x1.id);
      }
      for (let i of invites) {
        if (h.includes(i.id) === false) {
          z.push(i);
          k.push(i.id);
        }
      }

      setInvites(z);
      setIdsList(k);
    }
  };

  const inviteEmailButton = () => {
    if (isNullOrEmpty(idsList)) {
      toast.error("Please select at least one candidate");
      return;
    }
    history.push("/inviteviaemail", { idsList,pageList });
  };
  const inviteSmsButton = () => {
    if (isNullOrEmpty(idsList)) {
      toast.error("Please select at least one candidate");
      return;
    }
    history.push("/inviteviatext", { idsList });
  };
  const handleCallback = (googlePlaces) => {
    setAddress((prevState) => ({
      ...prevState,
      street: googlePlaces.street,
      area: googlePlaces.area,
      city: googlePlaces.city,
      state: googlePlaces.state,
      zipcode: googlePlaces.zipcode,
      country: googlePlaces.country,
      latitude: googlePlaces.latitude,
      longitude: googlePlaces.longitude,
    }));
  };

  const handleNoOfPeersSelectChange = (e) => {
    if (e.target.value == "") {
      setPeerRaters("");
    } else {
      setPeerRaters(e.target.value);
    }
  };
 
  return (
        <>
          <Card className="t-rounded-card">
            <CardBody>
              <FormGroup row>
                <Colxx sm={4}>
                  <Label className="lable-text">Search Candidates</Label>
                </Colxx>
              </FormGroup>

              <FormGroup row>
              <Colxx md={3}>
                  <FormGroup>
                    <Input
                      id="billingRate"
                      className="t-rounded-lg"
                      placeholder="First Name"
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                  </FormGroup>
                </Colxx>
                <Colxx md={3}>
                  <FormGroup>
                    <Input
                      id="billingRate"
                      className="t-rounded-lg"
                      placeholder="Last Name"
                      onChange={(e) => setLastName(e.target.value)}
                    />
                  </FormGroup>
                </Colxx>
                <Colxx md={3}>
                  <FormGroup>
                    <Input
                      id="billingRate"
                      className="t-rounded-lg"
                      placeholder="Email/Phone"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </FormGroup>
                </Colxx>
               
                  <Colxx md={3}>
                  <FormGroup row>
                    <Colxx md={5} className="t-day-input ">
                      <div>Registered within</div>
                    </Colxx>
                    <Colxx md={4}>
                      <Input
                        className="t-rounded-lg"
                        id="salaryType"
                        type="number"
                        onChange={(e) => setDays(e.target.value)}
                      />
                    </Colxx>
                    <Colxx md={3} className="t-day-input">
                      <span> days</span>
                    </Colxx>
                    <Colxx></Colxx>
                  </FormGroup>
                </Colxx>

              </FormGroup>

              <Row>
                 <Colxx md={3}>
                  <SearchPlaceComponent parentCallback={handleCallback} />
                </Colxx>
                <Colxx md={3}>
                  <FormGroup>
                    <Input
                      id="billingRate"
                      placeholder="Within 60 miles"
                      className="t-rounded-lg"
                      type="select"
                      value={distance}
                      onChange={(e) => setDistance(e.target.value)}
                    >
                      <option value="">Please Select Miles</option>
                      <option value="1">Within 1 mile </option>
                      <option value="2">Within 2 miles</option>
                      <option value="5">Within 5 miles</option>
                      <option value="10">Within 10 miles</option>
                      <option value="20">Within 20 miles</option>
                      <option value="25">Within 25 miles</option>
                      <option value="30">Within 30 miles</option>
                      <option value="40">Within 40 miles</option>
                      <option value="50">Within 50 miles</option>
                      <option value="75">Within 75 miles</option>
                      <option value="100">Within 100 miles</option>
                    </Input>
                  </FormGroup>
                </Colxx>
                <Colxx md={3}>
                  <Input
                    type="select"
                    className="t-rounded-lg"
                    onChange={handleNoOfPeersSelectChange}
                  >
                    <option value="">Any number of peers</option>
                    <option value="1">1+ peers</option>
                    <option value="2">2+ peers</option>
                    <option value="3">3+ peers</option>
                    <option value="4">4+ peers</option>
                    <option value="5">5+ peers</option>
                    <option value="10">10+ peers</option>
                    <option value="25">25+ peers</option>
                  </Input>
                </Colxx>
                <Colxx md={3}>
                  <Input
                    className="t-rounded-lg"
                    type="select"
                    value={itemsPerPage}
                    onChange={handleItemsPerChange}
                  >
                    <option value={""}>Items Per Page</option>
                    <option value={"10"}>10</option>
                    <option value={"25"}>25</option>
                    <option value={"50"}>50</option>
                    <option value={"100"}>100</option>
                  </Input>
                </Colxx>
              </Row>

              <Row>
                <Colxx md={4}>
                  <FormGroup>
                    <Input
                      className="t-rounded-lg"
                      onChange={(e) => setJobId(e.target.value)}
                      placeholder="Job Id"
                    />
                  </FormGroup>
                </Colxx>{" "}
                <Colxx className="mt-2"> or</Colxx>
                <Colxx className="t-button-flex-end">
                  <SkillSearch
                    parentCallback={skillSearchFunction}
                    deletedList={deleteSkill}
                  />
                  <SoftSkillSearch
                    parentCallback={softSkillFunction}
                    deletedList={deleteSoftSkill}
                  />
                  <LanguageSearch
                    parentCallback={languageFunction}
                    deletedList={deleteLanguage}
                  />
                  <CertificationSearch
                    parentCallback={certificationSearchFunction}
                    deletedList={deleteCertification}
                  />
                </Colxx>
              </Row>
              <Row>
                <Colxx className="t-button-flex-end">
                  {totalSkillList.length > 0 && (
                    <div>
                      {totalSkillList.map((skill,index) => {
                        return (
                          <span key={skill.id}>
                          <button
                            className="btn-sm mt-3 t-skill-btn-color btn mr-0 "
                            type="submit"
                            outline
                          >
                            {" "}
                            {skill.name}
                            <span
                              onClick={() => deleteItem(skill)}
                              className="pl-2"
                            >
                              <img src={vector}></img>
                            </span>
                          </button>
                          </span>
                        );
                      })}
                    </div>
                  )}{" "}
                </Colxx>
              </Row>
              <Button
                className="btn-sm mt-3 t-button-search btn "
                type="submit"
                color="primary"
                outline
                onClick={Search}
              >
                Search
              </Button>
            </CardBody>
          </Card>
          <Card className="mt-3 mt-2 w-100 t-card-wid t-rounded-card">
            <CardBody>
                <div className="tableContainer">
                  <div className="tablewrapper">
                    <Row>
                      <Col className="ml-2">
                        <strong>Found {size} Candidates</strong>
                      </Col>
                      <Col className="flex t-justify-content-end">
                        <Button
                          outline
                          color="primary mr-2"
                          onClick={inviteEmailButton}
                        >
                          Invite via email
                        </Button>
                        <Button
                          outline
                          color="primary mr-2"
                          onClick={inviteSmsButton}
                        >
                          Invite via text
                        </Button>
                      </Col>
                    </Row>

                    <Table className="hms_table jobRequisition_table table-responsive t-table-line">
                      <thead>
                        <tr>
                          <th className="w-5">
                            <Input
                              className="t-checkbox-mr-left"
                              type="checkbox"
                              checked={pageList.includes(currentPage)}
                              onChange={(e) => checkAllFunction(e)}
                            />
                            <span className="ml-3">All</span>
                          </th>

                          <th className="w-10">Name</th>
                          <th className="w-15">Email</th>
                          <th className="w-15">Phone</th>

                          <th className="w-20">Location</th>

                          <th className="w-10">Registered</th>

                          <th className="w-5">Ratings</th>

                          <th className="w-20">Reqs</th>
                          <th className="w-10"></th>
                        </tr>
                      </thead>

                      {candidates.length > 0 &&
                        candidates.map((item, index) => (
                          <tbody key={index}>
                            <tr key={index}>
                              <td className="w-180">
                                <Input
                                  className="t-checkbox-mr-left"
                                  type="checkbox"
                                  checked={[...idsList].includes(item.id)}
                                  onChange={(e) => checkFunction(e, item)}
                                />
                              </td>
                              <td className="w-180 t-search-primarycolor">
                                {item.firstName} {item.lastName}
                              </td>
                              <td className="w-180 t-search-email-font">{item.email}</td>
                              <td className="w-180">
                                {formattedMobileNumber(item.contactNumber)}
                              </td>
                              <td className="w-180">
                                {showCityState(item.workLocation)}
                              </td>
                              <td className="w-180">
                                {dayDifference(item.createdOn)}
                              </td>
                              <td className="w-180">{item.peerRaters}</td>
                              <td className="w-180">
                                <div>
                                  {item.jobApplications.length > 0 &&
                                    item.jobApplications
                                      .slice(0, 3)
                                      .map((employer, index) => (
                                      
                                          <ul className="mb-0 t-margin-left-job" key={index}>
                                            {" "}
                                            <Link 
                                            //  to={`/viewcandidatedetails/${employer.jobId}/${employer.applicationId}/`} 
                                             to={{pathname:`/viewcandidatedetails/${employer.jobId}/${employer.applicationId}`,
                                           state: {componentName: "searchCandidates"}
                                            }}

                                             className="ml-3 mr-1" >
                                            <u className="text-dark">{employer.employerJobId}</u></Link>-{" "}
                                            {employer.applicantStatus.value}{" "}
                                          </ul>
                                      
                                      ))}
                                </div>
                                {item.jobApplications.length > 3 ? (
                              
                                    <span
                                      className="t-read-more-color t-cursor-pointer"
                                      onClick={() => handleToolTip(item.id)}
                                      
                                    >
                                     {showTooltip == true && candId === item.id ? "Read Less":"Read More" }  

                                    </span>
                              
                                ) : (
                                  <></>
                                )}
                                {showTooltip && candId === item.id && (
                                  <>
                                    {item.jobApplications.length > 3 ? (
                                  
                                        <div className="t-tooltip-searchcand">
                                          <Row>
                                            <Col sm={8} className="t-padding-right-tooltip">
                                              <div>
                                                {item.jobApplications.length >
                                                  3 &&
                                                  item.jobApplications
                                                    .slice(
                                                      3,
                                                      item.jobApplications
                                                        .length
                                                    )
                                                    .map((employer, index) => (
                                                    
                                                        <ul className="mb-0 t-margin-left-job" key={index}>
                                                          {" "}
                                                          <Link 
                                             to={{pathname:`/viewcandidatedetails/${employer.jobId}/${employer.applicationId}`,
                                             state: {componentName: "searchCandidates"}
                                              }}
                                             className="ml-3 mr-1">
                                                          <u className="t-jobid-color">{employer.employerJobId}</u></Link>{" "}
                                                          -{" "}
                                                          {
                                                            employer
                                                              .applicantStatus
                                                              .value
                                                          }{" "}
                                                        </ul>
                                                     
                                                    ))}
                                              </div>
                                            </Col>
                                            <Col sm={4}>
                                              {item.jobApplications.length >
                                                3 &&
                                                item.jobApplications
                                                  .slice(
                                                    3,
                                                    item.jobApplications.length
                                                  )
                                                  .map((employer, index) => (
                                                      <ul className="mb-0" key={index}>
                                                        <span>
                                                          {" "}
                                                          {dateDifference(
                                                            employer.modifiedOn
                                                          )}
                                                        </span>
                                                      </ul>
                                                  ))}
                                            </Col>
                                          </Row>
                                        </div>
                                     
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                )}
                              </td>
                              <td className="w-180">
                                <div>
                                  {item.jobApplications.length > 0 &&
                                    item.jobApplications
                                      .slice(0, 3)
                                      .map((employer, index) => (
                                          <ul className="mb-0" key={index}>
                                            {" "}
                                            {dateDifference(employer.modifiedOn)}
                                          </ul>
                                      ))}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        ))}
                    </Table>
                  </div>
              
              </div>
            </CardBody>
            <CardFooter className="t-rounded-card">
              <Row className="wrapper">
                <h3 className="ml-3 matrecords">
                  {" "}
                  Total matching records : {size}
                </h3>
                <Pagination
                  currentPage={currentPage}
                  totalPage={totalPage}
                  numberLimit={5}
                  firstIsActive={true}
                  onChangePage={(e) => onChangePage(e)}
                />
              </Row>
            </CardFooter>
          </Card>
        </>
 
  );
};
export default SearchCandidate;
